<template>
  <div class="layered-background">
    <div
      class="positioner"
      :style="computedStyles"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalAlertLayout',
  props: {
    width: {
      type: String,
      default: '50%',
    },
    maxWidth: {
      type: String,
      default: '400px',
    },
  },
  computed: {
    computedStyles() {
      const arr = [];
      arr.push({
        width: this.width,
      });
      arr.push({
        maxWidth: this.maxWidth,
      });
      return arr;
    },
  },
  methods: {

  },
};
</script>
<style scoped>
.layered-background {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 90000;
}
.positioner {

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/global/GlobalAlertLayout.vue